import axios from 'axios';
import { toast } from 'sonner';

const KEY = 'bc_offline_applications';
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
let flushing = false;

export const readQueue = () => {
  try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch { return []; }
};

const writeQueue = (items) => {
  localStorage.setItem(KEY, JSON.stringify(items));
  window.dispatchEvent(new Event('bc-offline-queue-change'));
};

export const isNetworkError = (error) => !error.response || error.code === 'ERR_NETWORK';

export const queueApplication = (payload, jobTitle) => {
  const items = readQueue().filter((i) => i.payload.job_id !== payload.job_id);
  items.push({ id: `${payload.job_id}-${Date.now()}`, payload, jobTitle, queued_at: new Date().toISOString() });
  writeQueue(items);
};

export const removeQueued = (id) => writeQueue(readQueue().filter((i) => i.id !== id));

export const pendingForJob = (jobId) => readQueue().find((i) => i.payload.job_id === jobId);

// Send every queued application; keep the ones that still fail because of the network
export const flushQueue = async () => {
  if (flushing || !navigator.onLine) return;
  const items = readQueue();
  if (items.length === 0) return;
  flushing = true;
  try {
    for (const item of items) {
      try {
        await axios.post(`${API}/applications`, item.payload, { withCredentials: true });
        removeQueued(item.id);
        toast.success(`Candidature hors ligne envoyée : ${item.jobTitle || 'chantier'}`, { duration: 8000 });
      } catch (error) {
        if (isNetworkError(error)) break;
        removeQueued(item.id);
        const detail = error.response?.data?.detail;
        toast.error(`Candidature « ${item.jobTitle || 'chantier'} » refusée : ${typeof detail === 'string' ? detail : 'erreur serveur'}`, { duration: 10000 });
      }
    }
  } finally {
    flushing = false;
  }
};
